export default "__VITE_ASSET__CvsWKZi$__"